import UserDataSource, {ICreateAccountData} from "data/UserDataSource";

declare var $:any;
declare var navigator:any;

import { observable, computed, action } from "mobx";
import { getUrlParameter } from 'utils';
import { IconFactory } from 'components/widgets/icons';
import {PageEnum, PageEnums} from "components/nav/PageEnums";
import {User} from "data/entities/User";
import DashboardData from "./DashboardData";
import {ISolution,  solutionDataSource, SolutionType} from "./SolutionDataSource";
import {FeedData} from "./FeedData";
import {DashboardSolution} from "./entities/DashboardSolution";
import {BundleData} from "./BundleData";
import {API} from "../api";
import {IRegistration} from "./entities/IUser";
import dashboardData from "./DashboardData";
import LiveEventData from "./LiveEventData";
import * as moment from "moment-timezone";
import {Alert} from "./Alert";
import {ResData} from "components/reservations/ResData";
import {HREmailData} from "data/hr/HREmailData";
import {HRDashboardData} from "data/hr/HRDashboardData";
import {Transport} from "data/transport";

export const WellnessTabs = {
  JOURNAL:'journal',
  TRACKERS:'trackers',
  GOALS:'goals',
  PROFILE:'profile',
}


export const BROWSER_SUGGESTION = "We strongly suggest using an up to date version of Chrome, Firefox, Edge, or Safari.";
export const TRACKER_BAR_HEIGHT = 130;
export const HEADER_BAR_HEIGHT = 200;
export const MOBILE_TITLEBAR_HEIGHT = 60;

const DEFAULT_HOST = {
  avatar: "/res/avatars/Caitlin Porter_avatar.jpg",
  dateCreated: "2019-11-05T22:40:46.417Z",
  firstName: "Caitlin",
  id: "5dc1fa6ef5069c1e1f5d09fa",
  isDietitian: true,
  lastName: "Porter",
  nameOrNickname: "Caitlin Porter",
  _id: "5dc1fa6ef5069c1e1f5d09fa",
}

class _UIState {

  @observable hashParams;
  @observable notifications;  
  @observable pickATimeVenueId = "0";
  @observable signupInProgress = false;
  @observable private _currentPage = PageEnums.loading;
  @observable currentCustomPageKey:string;
  @observable internetExplorerDetected:boolean;
  @observable windowWidth:number;
  @observable windowHeight:number;
  @observable iOS:boolean = false;
  @observable _healthFairHost:any;
  @observable settings:any = null;

  dashboardData:HRDashboardData;
  emailData:HREmailData;
  @observable hrPleaseWait = false;
  @observable hrAlertTitle:string = '';
  @observable hrAlertDetails:string = '';



  @action hrCloseAlert = () => {
    this.hrAlertTitle = '';
    this.hrAlertDetails = '';
  }

  @action hrOpenAlert = (_alertTitle, _alertDetails) => {
    this.hrPleaseWait = false;
    this.hrAlertTitle = _alertTitle;
    this.hrAlertDetails = _alertDetails;
  }

  @action hrClosePleaseWait = () => {
    this.hrCloseAlert();
  }

  @action hrOpenPleaseWait = (_alertTitle?:string) => {
    this.hrPleaseWait = true;
    this.hrAlertTitle = _alertTitle?_alertTitle:"Please Wait";
  }


  /* @ts-ignore */
  @observable private _user:User = null;
  @computed get user() {
    return this._user;
  }

  // update now once per second
  @observable now;
  @action updateNow = () => {
    this.now = moment();
    setTimeout(() => this.updateNow(), 1000);
  }




  /**
   * Every rendered page in a challenge or
   * Health Fair relies on this for the h1
   * at the top.
   */
  @computed get currentPageTitle() {
    if(this._currentPage===PageEnums.custom) {
      return this.currentCustomPage ? this.currentCustomPage.title : "Custom Page";
    } else if(this._currentPage===PageEnums.booth) {
      return BundleData.selectedBundle ? BundleData.selectedBundle.fullName : "Booth";
    } else if(this._currentPage===PageEnums.feedLandingPage) {
      return this.isHealthFairMode ? "Event Feed" : "Feed";
    } else if(this._currentPage===PageEnums.prizes) {
      return this.feedData.solution.prizesPageName ? this.feedData.solution.prizesPageName : "Prizes";
    } else if(this._currentPage===PageEnums.myWellness) {
      // TODO: a more intelligent approach that takes into consideration what features are enabled needs to be implemented
      return UIState.isGoals ? "Goals" : "My Wellness";
    } else {
      return this._currentPage.title;
    }

  }

  @computed get currentPage() {
    return this._currentPage;
  }

  set currentPage(page:PageEnum) {
    if(page!=PageEnums.custom) {
      // clear the customPageKey
      this.currentCustomPageKey='';
    }
    if(page!=PageEnums.booth) {
      BundleData.selectedBundleId = '';
    }
    this._currentPage = page;
  }

  setCurrentPageByName(pageName:string) {
    const pageEnum = PageEnums[pageName];
    if(null!=pageEnum) {
      this.currentPage = pageEnum;
    } else {
      console.log('Failed to load page '+pageName)
    }
  }

  @computed get currentCustomPage():any {
    if(this.feedData.feedLoaded) {
      return this.feedData.solution.customPages.find(customPage=>customPage.key===this.currentCustomPageKey);
    } else {
      return null;
    }
  }

  @computed
  get healthFairHost() {
    return this._healthFairHost?this._healthFairHost:DEFAULT_HOST;
  }

  @computed
  get trackerBarEnabled() {
    return this.settings.ENABLE_TRACKERS?true:false;
  }


  @computed
  get fullsizedHeader() {
    return (this.trackerBarEnabled?TRACKER_BAR_HEIGHT:HEADER_BAR_HEIGHT); 
  }

  @computed
  get isMobile() {
    return this.windowWidth<901;
  }

  @observable private _wellnessTab:string = WellnessTabs.JOURNAL;
  set wellnessTab(tabName:string) {
    this._wellnessTab = tabName;
  }

  @computed 
  get wellnessTab() {
    return this._wellnessTab;
  }

  @computed get isJournal() { return this._wellnessTab===WellnessTabs.JOURNAL; }
  @computed get isTrackers() { return this._wellnessTab===WellnessTabs.TRACKERS; }
  @computed get isGoals() { return this._wellnessTab===WellnessTabs.GOALS; }
  @computed get isProfile() { return this._wellnessTab===WellnessTabs.PROFILE; }

  /**
   * Retrieve portal settings and then check whether there
   * is an authorized user.
   */
  @action
  loadSettings = () => new Promise<void>((resolve, reject) => {
    Transport.GET('/settings')
      .then((data:any)=>{

        const openForLogin = getUrlParameter('OPEN_FOR_LOGIN');
        if(openForLogin && openForLogin=='true') {
          data.PLATFORM_OPEN = true;
        }
        if(data.ENABLE_SAML_SSO && 'false' === getUrlParameter('SSO')) {
          data.ENABLE_SAML_SSO = false;
        }
        this.settings = data;
        this._wellnessTab = data.ENABLE_JOURNAL ? WellnessTabs.JOURNAL : WellnessTabs.PROFILE;
        IconFactory.updateDefaults(data.DEF_TRACKER_OPTIONS);
        UserDataSource.checkAuth()
          .then((response:any)=>{
            this._user = new User(response.user);
            UIState.loadDashboard();
            resolve();
          })
          .catch(()=>{
            UIState.clear();
            reject();
          });

      })
      .catch((reason)=>{
        console.log(reason);
        reject();
      });


    //
    // $.ajax({ dataType:'json', type:'GET', url: URL('/settings') })
    // .done((data)=>{
    //
    //
    //   const openForLogin = getUrlParameter('OPEN_FOR_LOGIN');
    //   if(openForLogin && openForLogin=='true') {
    //     data.PLATFORM_OPEN = true;
    //   }
    //   if(data.ENABLE_SAML_SSO && 'false' === getUrlParameter('SSO')) {
    //     data.ENABLE_SAML_SSO = false;
    //   }
    //
    //
    //   this.settings = data;
    //   this._wellnessTab = data.ENABLE_JOURNAL ? WellnessTabs.JOURNAL : WellnessTabs.PROFILE;
    //   IconFactory.updateDefaults(data.DEF_TRACKER_OPTIONS);
    //   UserDataSource.checkAuth()
    //     .then((response:any)=>{
    //       this._user = new User(response.user);
    //       UIState.loadDashboard();
    //       resolve();
    //     })
    //     .catch(()=>{
    //       UIState.clear();
    //       reject();
    //     });
    // })
    // .fail(()=>{
    //   reject();
    // });
  });

  @action clear = () => {
    // httpOnly cookie must be deleted on the server side
    // document.cookie = 'strive=; path=/; domain=.well-concepts.com; expires=' + new Date(0).toUTCString();
    localStorage.removeItem('token');
    // @ts-ignore
    this._user = null;
    this.currentPage = PageEnums.login;
  }

  // @action clearState = () => {
  //   document.cookie = 'strive=; path=/; domain=.well-concepts.com; expires=' + new Date(0).toUTCString();
  //   localStorage.removeItem('token');
  //   // @ts-ignore
  //   this._user = null;
  //   this.currentPage = PageEnums.login;
  // }

  @action createUserAccount = (data:ICreateAccountData) => new Promise<void>((resolve, reject) => {
    UserDataSource.createUserAccount(data)
      .then((response)=>{
        localStorage.setItem('token', response.token);
        this._user = new User(response.user);
        resolve();
      })
      .catch((reason)=>{
        reject(reason);
      })
  })

  @action deleteAccount = (email:string, password:string) => new Promise<void>((resolve, reject) => {
    UserDataSource.deleteUserAccount(email, password)
      .then(()=>{
        this.clear();
        resolve();
      })
      .catch(()=>{
        reject();
      });
  });

  @action attemptLogin = (email:string, password:string) => new Promise<void>((resolve, reject) => {
    UserDataSource.attemptLogin(email, password)
      .then((response:any)=>{
        localStorage.setItem('token', response.token);
        this._user = new User(response.user);
        this.currentPage = PageEnums.dashboard;
        resolve();
      })
      .catch((err)=>{
        reject(err);
      });
  })



  loadDashboard = () => {
    solutionDataSource.checkInToOnsiteBoothFromCookies()
      .then(()=>{
      DashboardData.load()
        .then(action(() => {
          UIState.signupInProgress = false;
          UIState.currentPage = PageEnums.dashboard;
          LiveEventData.start();
          if(this._user.isClientContact) {
            this.dashboardData = new HRDashboardData();
            this.emailData = new HREmailData();
          }
        }))
        .catch((reason) => {
          console.log(reason);
          Alert.alert('Failed to load the dashboard. Please reload your browser.');
        });
    });
  }



  registerForSolution = (solutionId:string) => new Promise<void>((resolve, reject) => {
    API.get('/cmd/registerForSolution/'+solutionId)
      .then((registration:IRegistration)=>{
        if(!this.user.registrations) {
          this.user.registrations = [];
        }
        this.user.registrations.push(registration);
        resolve();
      })
      .catch((err)=>{
        reject(err);
      });
  });

  selectDashboardSolution = (dashboardSolution:DashboardSolution) => {
    if(dashboardSolution.isDashboardLink) {
      window.open(dashboardSolution.externalLink, '_blank');
    } else {
      dashboardData.selectedDashboardSolution = dashboardSolution;
      if ((dashboardSolution.alwaysAvailable || dashboardSolution.autoRegister) || ((this.user.isAdmin || dashboardSolution.isOpen) && dashboardSolution.registered)) {
        this.loadSolution(dashboardSolution)
          .then(() => {
            if (SolutionType.CHALLENGE === dashboardSolution.type || SolutionType.HEALTH_FAIR === dashboardSolution.type) {
              this.currentPage = PageEnums.feedLandingPage;
            } else {
              this.currentPage = PageEnums.solutionDetail;
            }
          })
          .catch((err) => {
            console.log(err);
            Alert.alert('Failed to load ' + dashboardSolution.name + '. Please make sure your internet connection is stable and try again.')
          });
      } else {
        this.currentPage = PageEnums.solutionRegister;
      }
    }
  }

  @observable feedData:FeedData;
  loadSolution = (dashboardSolution:DashboardSolution) => new Promise<void>(((resolve, reject) => {
    solutionDataSource.solutionForId(dashboardSolution._id)
      .then((solution: ISolution) => {
        FeedData.feedDataFactory(solution)
          .then((feedData:FeedData) => {
            this.feedData = feedData;
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      })
      .catch((err) => {
        reject(err);
      })
  }));


  @computed 
  get POJSisTouchDeviceConstant() {
    return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
  }

  showOverlayMask() {
    $('#overlay').addClass('show');
    $('#overlay div.mask').addClass('show'); //css('background-color', 'rgba(242, 166, 15, 1)');
  }
  
  hideOverlayMask() {
    $('#overlay div.mask').removeClass('show'); //.css('background-color', 'rgba(242, 166, 15, 0)');
    $('#overlay div.message').removeClass('show');
    setTimeout(function(){
      $('#overlay').removeClass('show');
    }, 500);
  }
  
  displayOverLayTitle(title) {
    $('#overlay div.message').html(title);
    $('#overlay div.message').addClass('show');
  }

  hideNav(){
    $('div.nav').addClass('hide');
    $('#LatentBackdrop').addClass('hide');
  }
  
  showNav(){
    $('div.nav').removeClass('hide');
    $('#LatentBackdrop').removeClass('hide');
  }

  POJSshowFullBrowserMask() {
    $('#fullbrowser').addClass('show');
    $('#fullbrowser div.mask').addClass('show');
  }

  POJShideFullBrowserMask() {
    $('#fullbrowser div.mask').removeClass('show');
    setTimeout(function(){
      $('#fullbrowser').removeClass('show');
    }, 500);
  }
  
  dismissNotification(notification){
    notification.dismissed = true;

    Transport.PUT(`/notifications/${notification._id}`, {dismissed:true})
      .then()
      .catch((reason)=>{
        console.log(reason)
      });
    // //render();
    // $.ajax({
    //   contentType:"application/json; charset=utf-8",
    //   dataType:'json',
    //   headers: { 'Authorization':'Token '+localStorage.getItem('token') },
    //   type:'PUT',
    //   url: URL(`/notifications/${notification._id}`),
    //   data:JSON.stringify({dismissed:true})
    // })
    // .done(function(response){
    //   //ajaxGetNotifications();
    // })
    // .error( function(jqXHR, textStatus, errorThrown ){
    //
    // });
  }

  @action
  handleWindowResize = () => {
    this.windowWidth = document.documentElement.clientWidth;
    this.windowHeight = document.documentElement.clientHeight;
  }

  @computed get isHealthFairMode() {
    return this.feedData && this.feedData.feedLoaded && this.feedData.solution.type===SolutionType.HEALTH_FAIR;
  }

  @action
  extractHashParams = () => {
    let _hashParams = {};
    const query = location.hash.replace('#','');
    if(''!=query) {
      let match;
      const pl     = /\+/g;  // Regex for replacing addition symbol with a space
      const search = /([^&=]+)=?([^&]*)/g;
      const decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); }
      while (match = search.exec(query)){
        _hashParams[decode(match[1])] = decode(match[2]);
      }

      // clear the browser hash
      location.hash = '';
    }
    this.hashParams = _hashParams;
  }

  @action
  setHealthFairHost = (healthFairHost:any) => {
    this._healthFairHost = healthFairHost;
  }

  @observable resData:ResData|null;
  private onCloseScheduler:(resData:ResData|null)=>void = () => {};

  @action openScheduler = (resData:ResData, onClose:(resData:ResData)=>void) => {
    this.resData = resData;
    this.onCloseScheduler = onClose;
  }
  @action closeScheduler = () => {
    this.onCloseScheduler(this.resData);
    this.resData = null;
  }


  constructor() {
    this.iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    this.extractHashParams();
    this.internetExplorerDetected = /MSIE \d|Trident.*rv:/.test(navigator.userAgent);
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();
    this.updateNow();
  }

}

const UIState = new _UIState();
export { UIState };
